import {
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from '@mui/material';
import React from 'react';

import CheckedRadioIcon from '../../../../packages/common/shared-ui/src/icons/CheckedRadioIcon';
import UncheckedRadioIcon from '../../../../packages/common/shared-ui/src/icons/UncheckedRadioIcon';
import { useTranslation } from '../../../../packages/common/utils/getLocalString';

const ResourcePlanUndefinedError = ({
  setIsClearing,
  setIsSaving,
  setShowUndefinedError,
}) => {
  const getLocalString = useTranslation();
  const [optionValue, setOptionValue] = React.useState('save_all');
  const handleClick = () => {
    if (optionValue === 'save_all') {
      setIsSaving(true);
    } else if (optionValue === 'cancel_changes') {
      setIsClearing(true);
    }
    setShowUndefinedError(false);
  };
  return (
    <Grid
      container
      direction='column'
      sx={{
        marginBottom: 2,
      }}
    >
      <Typography
        variant='h3'
        sx={{
          fontWeight: 600,
          color: '#E03737',
        }}
      >
        {getLocalString('errors', 'errorOccurred')}
      </Typography>
      <Grid
        container
        wrap='nowrap'
        direction='column'
        spacing={0}
        sx={{
          marginLeft: 4,
        }}
      >
        <RadioGroup
          value={optionValue}
          onChange={e => setOptionValue(e.target.value)}
          defaultValue={0}
        >
          <FormControlLabel
            value='save_all'
            control={
              <Radio
                disableRipple
                icon={
                  <UncheckedRadioIcon
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                  />
                }
                checkedIcon={
                  <CheckedRadioIcon
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                  />
                }
              />
            }
            label={getLocalString('messages', 'saveMyChanges')}
          />
          <FormControlLabel
            value='cancel_changes'
            control={
              <Radio
                disableRipple
                icon={
                  <UncheckedRadioIcon
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                  />
                }
                checkedIcon={
                  <CheckedRadioIcon
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                  />
                }
              />
            }
            label={getLocalString('errors', 'clearingChanges')}
          />
        </RadioGroup>
        <Grid>
          <Button
            variant='defaultBluePrimary'
            disableRipple
            onClick={handleClick}
          >
            <Typography
              variant='h4'
              sx={{
                fontWeight: 600,
              }}
            >
              {getLocalString('labels', 'accept')}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ResourcePlanUndefinedError;
